module.exports = __webpack_public_path__ + "static/media/grentongrafika.7a5493a7.png";